import { Toaster as Sonner, toast } from 'sonner';

export function BalmartToaster() {
  return (
    <Sonner
      position="bottom-right"
      duration={3200}
      theme="light"
      toastOptions={{
        style: {
          background: '#FFFBF4',
          color: '#0A0A0A',
          border: '1px solid #E5E0D5',
          borderRadius: '0',
          fontFamily: "'Manrope', sans-serif",
          fontSize: '13px',
          padding: '14px 18px',
          letterSpacing: '0.01em',
          boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
        },
        className: 'balmart-toast',
      }}
    />
  );
}

// Branded toast helpers
export const notify = {
  success: (msg) => toast.success(msg, { style: { borderLeft: '3px solid #B80000' } }),
  info: (msg) => toast(msg, { style: { borderLeft: '3px solid #000' } }),
  error: (msg) => toast.error(msg, { style: { borderLeft: '3px solid #B80000', color: '#B80000' } }),
};

export { toast };
